/* ============================================================================
   Nintara — Diaper Bag PDP  (assets/diaper-bag-pdp.js, loaded with `defer`)

   NO LIQUID IN HERE. Asset files are served statically and are never rendered
   through Liquid, so {{ ... }} would reach the browser verbatim and throw a
   SyntaxError that kills the whole file. Config comes off the section root as
   data attributes instead — same contract as diaper-bag-tabs.js.

   MULTI-INSTANCE: this section renders twice (Backpack + Duffle), so the
   <script src> tag is emitted twice and this file executes twice. The load
   guard makes the second execution a no-op, and initAll() wires up EVERY
   [data-nbp] root rather than one hardcoded section id.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__nintaraPdpLoaded) return;
  window.__nintaraPdpLoaded = true;

    /* ==========================================================
     SHARED CART READ + MUTATION HOOK  (module scope — once)
     Both bag-type instances share one read. The endpoint hook is
     what makes a removal IN THE DRAWER roll the sticky button back
     from VIEW CART to ADD TO CART: the drawer posts /cart/change.js,
     we see it land, re-read, and re-paint.
     ========================================================== */
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|#)/;
  var _cartInFlight = null;

    /* Money — mirrors Liquid's money_without_trailing_zeros so the cart total
     never formats differently from the per-product prices. */
  var MONEY_FORMAT = (function () {
    var r = document.querySelector('[data-nbp]');
    return (r && r.getAttribute('data-money-format')) || '₹{{amount}}';
  })();

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(cents) || cents === null) return '0';
    var parts = (cents / 100.0).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents) {
    try {
      var ph = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!ph) return MONEY_FORMAT;
      var value;
      switch (ph[1]) {
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      value = value.replace(/[.,]00$/, '');   /* match money_without_trailing_zeros */
      return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, value);
    } catch (e) {
      return '₹' + Math.round(cents / 100);
    }
  }

  /* /cart.js does NOT expose compare_at_price on line items, so the
     strikethrough has to come from /products/{handle}.js. Same fallback
     ladder as sticky-cart-js-file.js — keep the two in sync. */
  var _productCache = {};

  function computeCompareTotal(cart) {
    var items = cart.items || [];
    var handles = items.map(function (i) { return i.handle; })
      .filter(function (h, idx, a) { return h && a.indexOf(h) === idx && !_productCache[h]; });

    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { _productCache[h] = d; })
        .catch(function () {});
    })).then(function () {
      var sum = 0;
      items.forEach(function (item) {
        var pd = _productCache[item.handle];
        var v = pd && pd.variants && pd.variants.filter(function (x) { return x.id === item.variant_id; })[0];
        if (v) sum += ((v.compare_at_price > 0 ? v.compare_at_price : v.price) * item.quantity);
        else sum += (item.price * item.quantity);   /* no saving for that line */
      });
      if (sum > 0 && sum > cart.total_price) return sum;
      if (cart.original_total_price > cart.total_price) return cart.original_total_price;
      return 0;
    });
  }

  function readCartShared() {
    if (_cartInFlight) return _cartInFlight;          /* dedupe concurrent calls */
    _cartInFlight = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
            .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .t4s-cart-count, #sticky-cart-count, #cart-quantity')
          .forEach(function (el) { el.textContent = cart.item_count; });
        return computeCompareTotal(cart).then(function (cmp) {
          cart.__compareTotal = cmp;
          document.dispatchEvent(new CustomEvent('nintara:cartupdated', { detail: { cart: cart } }));
          return cart;
        });
      })
      .catch(function () {})
      .then(function (c) { _cartInFlight = null; return c; });
    return _cartInFlight;
  }

  /* NOTE the flag name: sticky-cart-js-file.js patches window.fetch with its own
     __stickyHooked guard. Reusing that name would make THIS patch skip whenever
     that file loaded first. Separate flag -> both wrappers coexist. */
  (function hookCartMutations() {
    var fire = function () { setTimeout(readCartShared, 60); };  /* let the server commit */

    var origFetch = window.fetch;
    if (origFetch && !origFetch.__nbpHooked) {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isMut = CART_MUTATION_RE.test(String(url));
        return origFetch.apply(this, arguments).then(function (res) { if (isMut) fire(); return res; });
      };
      window.fetch.__nbpHooked = true;
    }

    var origOpen = XMLHttpRequest.prototype.open;
    if (origOpen && !origOpen.__nbpHooked) {
      XMLHttpRequest.prototype.open = function (m, url) {
        this.__nbpMut = CART_MUTATION_RE.test(String(url || ''));
        return origOpen.apply(this, arguments);
      };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__nbpMut) this.addEventListener('loadend', fire);
        return origSend.apply(this, arguments);
      };
      XMLHttpRequest.prototype.open.__nbpHooked = true;
    }
  })();

  /* The theme's own sticky bar reads the cart too and announces it — free
     second signal, costs nothing. */
    /* The theme's own sticky bar reads the cart too — use it as a trigger and
     do our own full read, since its payload carries no compare-at data. */
  document.addEventListener('sticky-cart:updated', function () {
    readCartShared();
  });

  /* A change made in another tab, or the drawer closing after a removal. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) readCartShared();
  });

  /*changes end*/

  function initRoot(root) {
    if (!root || root.__nbpInit) return;
    root.__nbpInit = true;

    var BAG      = root.getAttribute('data-bag-type');
    var panes    = Array.prototype.slice.call(root.querySelectorAll('[data-nbp-pane]'));
    var status   = root.querySelector('[data-nbp-status]');
    var sticky   = root.querySelector('[data-nbp-sticky]');
    var CART_URL = root.getAttribute('data-cart-url') || '/cart';
    var LABELS   = {
      atc:   root.getAttribute('data-label-atc')   || 'ADD TO CART',
      sold:  root.getAttribute('data-label-sold')  || 'OUT OF STOCK',
      added: root.getAttribute('data-label-added') || 'ADDED',
      cart:  root.getAttribute('data-label-cart')  || 'VIEW CART'
    };
    if (!panes.length) return;

    /* ==========================================================
       1. Delivery window
       Same rule as delivery-date.js (today + min .. today + max,
       en-US "Mon D"), computed inline so there are no duplicate
       #delivery-date-range IDs in the document. The offsets are
       section settings.
       ========================================================== */
    (function fillDeliveryDates() {
      var min = parseInt(root.getAttribute('data-delivery-min'), 10);
      var max = parseInt(root.getAttribute('data-delivery-max'), 10);
      if (isNaN(min)) min = 2;
      if (isNaN(max)) max = 5;

      function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
      function add(days) { var d = new Date(); d.setDate(d.getDate() + days); return d; }

      var text = fmt(add(min)) + ' - ' + fmt(add(max));
      root.querySelectorAll('[data-nbp-dd]').forEach(function (el) { el.textContent = text; });
    })();

    /* ==========================================================
       2. Per-pane gallery
       ========================================================== */
    function initPane(pane) {
      var thumbs = Array.prototype.slice.call(pane.querySelectorAll('.nbp__thumb'));
      var medias = Array.prototype.slice.call(pane.querySelectorAll('.nbp__media'));
      var prev   = pane.querySelector('.nbp__arrow--prev');
      var next   = pane.querySelector('.nbp__arrow--next');
      if (!medias.length) return;

      var current = 0, last = medias.length - 1, ready = false;

        function show(i, opts) {
        if (i < 0) i = 0;
        if (i > last) i = last;
        current = i;

        medias.forEach(function (m) {
          var on = +m.getAttribute('data-nbp-index') === i;
          m.classList.toggle('is-active', on);
          if (!on && m.tagName === 'VIDEO' && m.pause) m.pause();
        });
        thumbs.forEach(function (t) {
          var on = +t.getAttribute('data-nbp-index') === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-current', on ? 'true' : 'false');
            if (ready && on && !(opts && opts.noScroll) && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        });
        if (prev) prev.classList.toggle('is-disabled', i === 0);
        if (next) next.classList.toggle('is-disabled', i === last);
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.getAttribute('data-nbp-index')); });
      });
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      show(0);
      ready = true;
      pane._show = show;

      /* Swipe */
      var main = pane.querySelector('.nbp__main');
      if (main && medias.length > 1) {
        var sx = 0, sy = 0, track = false;
        main.addEventListener('touchstart', function (e) {
          var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; track = true;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (!track) return; track = false;
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? current + 1 : current - 1);
        }, { passive: true });
      }

      /* Vertical page scroll must pass through the horizontal thumb rail */
      var rail = pane.querySelector('.nbp__thumbs');
      if (rail && 'ontouchstart' in window) {
        var rx = 0, ry = 0, ly = 0, axis = null;
        rail.addEventListener('touchstart', function (e) {
          var t = e.touches[0]; rx = t.clientX; ry = t.clientY; ly = t.clientY; axis = null;
        }, { passive: true });
        rail.addEventListener('touchmove', function (e) {
          var t = e.touches[0];
          if (axis === null) {
            var dx = Math.abs(t.clientX - rx), dy = Math.abs(t.clientY - ry);
            if (dx < 4 && dy < 4) return;
            axis = dx > dy ? 'x' : 'y';
          }
          if (axis === 'y') {
            if (e.cancelable) e.preventDefault();
            window.scrollBy(0, ly - t.clientY);
            ly = t.clientY;
          }
        }, { passive: false });
      }

      /* Pause video when the pane scrolls out of view */
      var videos = Array.prototype.slice.call(pane.querySelectorAll('video.nbp__media'));
      if (videos.length && 'IntersectionObserver' in window && main) {
        new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) videos.forEach(function (v) { if (v.pause) v.pause(); });
        }, { threshold: 0 }).observe(main);
      }
    }
    panes.forEach(initPane);

    /* ==========================================================
       3. Pane switching + cross-section state
       ========================================================== */
    function activePane() {
      return panes.filter(function (p) { return !p.hidden; })[0] || panes[0];
    }

    function paintSticky(pane) {
      if (!sticky) return;
      var thumb   = sticky.querySelector('[data-nbp-sticky-thumb]');
      var sale    = sticky.querySelector('[data-nbp-sticky-sale]');
      var compare = sticky.querySelector('[data-nbp-sticky-compare]');
      var btn     = sticky.querySelector('[data-nbp-sticky-atc]');
      var img     = pane.querySelector('img.nbp__media') || pane.querySelector('.nbp__thumb img');

      if (thumb && img) thumb.src = img.currentSrc || img.src;
      if (sale) sale.textContent = pane.getAttribute('data-price') || '';
      if (compare) compare.textContent = pane.getAttribute('data-compare') || '';

      if (btn) {
        btn.setAttribute('data-variant-id', pane.getAttribute('data-variant-id') || '');
    }
    paintStickyMode();
    }

    function showPane(pane, opts) {
      if (!pane) return;
      opts = opts || {};

      panes.forEach(function (p) {
        var on = p === pane;
        p.hidden = !on;
                if (on) { if (p._show) p._show(0, { noScroll: true }); }
        else p.querySelectorAll('video.nbp__media').forEach(function (v) { if (v.pause) v.pause(); });
      });

      paintSticky(pane);
       requestStickyTick();  

      var design = pane.getAttribute('data-design');

      /* The tab price follows the colour on screen. */
      document.dispatchEvent(new CustomEvent('nintara:productchange', {
        detail: { bagType: BAG, design: design, price: pane.getAttribute('data-price') }
      }));

      /* Remember the colour so the OTHER bag type lands on it too. */
      if (!opts.fromState) {
        window.NintaraLP = window.NintaraLP || {};
        window.NintaraLP.design = design;
        document.dispatchEvent(new CustomEvent('nintara:designchange', { detail: { design: design } }));
      }

      if (status && !opts.silent) {
        var t = pane.querySelector('.nbp__title');
        status.textContent = (t ? t.textContent.trim() : 'Product') + ' selected.';
      }
      if (opts.scrollTop) scrollToPaneTop();
    }

        /* A swatch swaps to a pane of a different height, so the reader can end up
       mid-section. Put the PDP block's top just under whatever is pinned. */
    function scrollToPaneTop() {
      var wrap = root.querySelector('.nbp__wrap') || root;
      function go() {
        var y = wrap.getBoundingClientRect().top - revealThreshold() - 8;
        if (Math.abs(y) < 2) return;
        window.scrollBy({ top: y, left: 0, behavior: 'auto' });
      }
      go();
      /* Scrolling can pin/unpin the tabs strip, which moves the threshold. */
      window.requestAnimationFrame(go);
    }

    function paneByDesign(design) {
      if (!design) return null;
      return panes.filter(function (p) { return p.getAttribute('data-design') === design; })[0] || null;
    }

    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var sw = e.target.closest('[data-nbp-swatch]');
      if (!sw) return;
      e.preventDefault();
      var target = paneByDesign(sw.getAttribute('data-nbp-swatch'));
        if (target) showPane(target, { scrollTop: true });
    });

    /* This instance just became the visible one — match the remembered colour. */
    document.addEventListener('nintara:bagchange', function (e) {
      if (!e.detail || e.detail.bagType !== BAG) return;
      var want = (window.NintaraLP && window.NintaraLP.design) || null;
      var target = paneByDesign(want) || activePane();
      showPane(target, { fromState: true, silent: true });
    });

    /* The other instance changed colour — mirror it silently, so the swap is
       already correct if the user tabs over. */
    document.addEventListener('nintara:designchange', function (e) {
      if (!e.detail) return;
      if (document.documentElement.getAttribute('data-bag-type') === BAG) return;
      var target = paneByDesign(e.detail.design);
      if (target) showPane(target, { fromState: true, silent: true });
    });

     /* ==========================================================
     4. Cart state, add to cart, and the VIEW CART handover
     ========================================================== */
  var stickyBtn = sticky ? sticky.querySelector('[data-nbp-sticky-atc]') : null;
  var CART = { items: [], item_count: 0 };
    var stickyCartLink = sticky ? sticky.querySelector('[data-nbp-sticky-cart]') : null;
  var _labelHoldUntil = 0;   /* lets "ADDED" sit for its 2s before VIEW CART */

    /* HANDOVER — "is the product ON SCREEN in the cart?", same rule as
     _hasThisProduct in sticky-cart-js-file.js. Another colour or bag type
     being in the cart does NOT hand this pane over. */
  function paneInCart(pane) {
    var h = pane.getAttribute('data-handle');
    if (!h || !CART.items) return false;
    return CART.items.some(function (i) { return i.handle === h; });
  }

  function paintStickyMode() {
    if (!stickyBtn) return;
    var pane = activePane();
    var available = pane.getAttribute('data-available') === 'true';
    var hasItems = CART.item_count > 0;
    var handedOver = paneInCart(pane);

    stickyBtn.setAttribute('data-nbp-mode', handedOver ? 'cart' : 'atc');
    stickyBtn.disabled = handedOver ? false : !available;

    if (sticky) {
      sticky.classList.toggle('is-cart-mode', handedOver);
      sticky.classList.toggle('has-items', hasItems);
    }
    var badge = sticky && sticky.querySelector('[data-nbp-sticky-count]');
    if (badge) badge.textContent = CART.item_count || 0;

    /* Cart totals when handed over, this product's price otherwise. */
    if (sticky) {
      var sale = sticky.querySelector('[data-nbp-sticky-sale]');
      var cmp  = sticky.querySelector('[data-nbp-sticky-compare]');
      if (handedOver) {
        if (sale) sale.textContent = formatMoney(CART.total_price || 0);
        if (cmp) cmp.textContent = CART.__compareTotal ? formatMoney(CART.__compareTotal) : '';
      } else {
        if (sale) sale.textContent = pane.getAttribute('data-price') || '';
        if (cmp) cmp.textContent = pane.getAttribute('data-compare') || '';
      }
    }

    if (Date.now() < _labelHoldUntil) return;
    var txt = stickyBtn.querySelector('.nbp__atc-text');
    if (!txt) return;
    txt.textContent = handedOver
      ? LABELS.cart + ' (' + CART.item_count + ')'
      : (available ? LABELS.atc : LABELS.sold);
  }

  /* The other bag-type instance already read the cart — reuse it, don't refetch. */
     document.addEventListener('nintara:cartupdated', function (e) {
      if (!e.detail || !e.detail.cart) return;
      var was = CART.item_count;
      CART = e.detail.cart;
      /* A removal must repaint immediately — don't let a lingering "ADDED"
         hold from a previous tap suppress the rollback to ADD TO CART. */
            if (CART.item_count !== was) _labelHoldUntil = 0;
      paintStickyMode();
      requestStickyTick();
    });
  /* This theme binds its drawer handler to the header trigger a#nin_web_cart,
     NOT to [data-drawer-options] — so clicking that node is what opens the
     mini cart. Falls back to /cart so the button is never dead. */
  function openCartDrawer() {
    var native = document.querySelector('a#nin_web_cart');
    if (native) { native.click(); return; }
    window.location.href = CART_URL;
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    var txt = btn.querySelector('.nbp__atc-text');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          if (txt) txt.textContent = (res.data && res.data.description) || 'Could not add';
          setTimeout(function () { if (txt) txt.textContent = LABELS.atc; paintStickyMode(); }, 2500);
          return;
        }
        if (txt) txt.textContent = LABELS.added;
        if (btn === stickyBtn) _labelHoldUntil = Date.now() + 2000;
        setTimeout(function () {
          if (txt) txt.textContent = LABELS.atc;
          paintStickyMode();               /* -> VIEW CART (n) */
        }, 2000);
        readCartShared();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'nintara_lp_add_to_cart',
          bag_type: BAG,
          design: activePane().getAttribute('data-design'),
          variant_id: id
        });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (txt) txt.textContent = LABELS.atc;
        paintStickyMode();
      });
  }

    root.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-nbp-atc]');
    if (!btn) return;
    if (btn.getAttribute('data-nbp-mode') === 'cart') {
      e.preventDefault();
      openCartDrawer();
      return;
    }
    addToCart(btn);
  });

  /* Behaviour two: the cart icon beside the ATC pill. */
  if (stickyCartLink) {
    stickyCartLink.addEventListener('click', function (e) {
      e.preventDefault();      /* kill the /cart navigation (the page-load flash) */
      openCartDrawer();
    });
  }


    /* ==========================================================
       5. Sticky ATC reveal
       Simple rule: the sticky bar is HIDDEN while the real in-page
       ATC is actually visible to the shopper (below the tabs strip
       and above the viewport bottom), and VISIBLE everywhere else on
       the page — including the first fold, before the ATC is reached,
       and after it scrolls up under the strip. Keyed to the tabs
       strip bottom, NOT the header. The 0×0 guard keeps the hidden
       bag half's bar down; desktop hides it via CSS.
       ========================================================== */
    var FOLD_HYSTERESIS = 24;
    var _revealed = false, _stickyTicking = false, _headerEl = null, _headerSticky = false;

    function headerBottom() {
      if (!_headerEl || !_headerEl.isConnected) {
        _headerEl = document.querySelector('.t4s-section-header');
        _headerSticky = _headerEl
          ? ['fixed', 'sticky'].indexOf(getComputedStyle(_headerEl).position) > -1
          : false;
      }
      if (!_headerEl || !_headerSticky) return 0;
      return Math.max(0, _headerEl.getBoundingClientRect().bottom);
    }

    /* Kept for scrollToPaneTop() — unchanged. */
    function revealThreshold() {
      var strip = document.querySelector('[data-nbt-strip]');
      if (strip && strip.classList.contains('is-stuck')) {
        return Math.max(0, strip.getBoundingClientRect().bottom);
      }
      return headerBottom();
    }

    /* The sticky reveal line: the TABS strip's bottom edge, whether it's pinned
       or still in flow near the top. Header is only a last resort if the tabs
       strip isn't on the page. */
    function stickyRevealLine() {
      var strip = document.querySelector('[data-nbt-strip]');
      if (strip) return Math.max(0, strip.getBoundingClientRect().bottom);
      return headerBottom();
    }

    function updateSticky() {
      _stickyTicking = false;
      if (!sticky) return;
      var main = activePane().querySelector('[data-nbp-atc]');
      if (!main) return;

      var r = main.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) {   /* this bag type is the hidden one */
        _revealed = false;
        sticky.classList.remove('is-visible');
        return;
      }

      /* VIEW CART is a different action from the in-page ADD TO CART, so keep
         the bar up at any scroll position. */
      if (stickyBtn && stickyBtn.getAttribute('data-nbp-mode') === 'cart') {
        _revealed = true;
        sticky.classList.add('is-visible');
        return;
      }

      /* The real ATC is genuinely visible to the shopper when it sits BELOW the
         tabs strip AND above the viewport bottom. Hide the sticky only then;
         show it everywhere else on the page — the first fold before the ATC is
         reached, and after it scrolls up under the strip. Hysteresis stops an
         edge wobble from flickering the bar. */
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var line = stickyRevealLine();
      var atcVisible = _revealed
        ? (r.top < vh - FOLD_HYSTERESIS && r.bottom > line + FOLD_HYSTERESIS)
        : (r.top < vh + FOLD_HYSTERESIS && r.bottom > line - FOLD_HYSTERESIS);
      _revealed = !atcVisible;
      sticky.classList.toggle('is-visible', _revealed);
    }

    function requestStickyTick() {
      if (!_stickyTicking) { _stickyTicking = true; window.requestAnimationFrame(updateSticky); }
    }

    if (sticky) {
      window.addEventListener('scroll', requestStickyTick, { passive: true });
      window.addEventListener('resize', function () { _headerEl = null; requestStickyTick(); }, { passive: true });
      document.addEventListener('nintara:bagchange', requestStickyTick);
    }

         /* ==========================================================
       6. Boot this instance
       ========================================================== */
    showPane(activePane(), { fromState: true, silent: true });
     readCartShared();         /* survives refresh: an item already in cart -> VIEW CART */
    requestStickyTick();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-nbp]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Theme editor re-render — the __nbpInit flag keeps already-wired roots safe. */
  document.addEventListener('shopify:section:load', initAll);
})();
